import React from 'react';

const UserDashboard = ({ user, token, onNavigate }) => {
  return (
    <div className="dashboard-container">
      <div className="dashboard">
        <h2>Kullanıcı Paneli</h2>
        <p>Hoş geldiniz, {user.full_name}!</p>

        <div className="dashboard-grid">
          <div className="dashboard-card" onClick={() => onNavigate('create-fault-report')}>
            <h3>🔧 Arıza Bildirimi</h3>
            <p>Sistem arızalarını bildirin</p>
          </div>
          
          <div className="dashboard-card" onClick={() => onNavigate('inventory-count')}>
            <h3>📊 Sayım Tamamlama</h3>
            <p>Sayım işlemlerini tamamlayın</p>
          </div>
          
          <div className="dashboard-card" onClick={() => onNavigate('create-change-request')}>
            <h3>🔄 Değişim Talebi</h3>
            <p>Değişim taleplerini oluşturun</p>
          </div>
          
          <div className="dashboard-card" onClick={() => onNavigate('create-general-request')}>
            <h3>✉️ Genel Talep</h3>
            <p>Diğer taleplerinizi iletin</p>
          </div>
          
          <div className="dashboard-card" onClick={() => onNavigate('my-tickets')}>
            <h3>📋 Taleplerim</h3>
            <p>Gönderdiğiniz talepleri görüntüleyin</p>
          </div>

          <div className="dashboard-card" onClick={() => onNavigate('my-inventory')}>
            <h3>📦 Envanter Listesi</h3>
            <p>Size atanan ürünleri görüntüleyin</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;